// Diagnostics: a small on-device log of errors and warnings (roadmap #9), so a
// bug seen on the phone can be copied out of Account → Diagnostics instead of
// being lost in a console nobody opens. Ring buffer of the last 50 entries in
// localStorage; nothing leaves the device unless the user copies it.

const KEY = "diagnostics:log";
const MAX = 50;
const MAX_TEXT = 500;

function read() {
	try {
		return JSON.parse(localStorage.getItem(KEY) ?? "[]");
	} catch {
		return [];
	}
}

function write(list) {
	try {
		localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX)));
	} catch {
		// storage full / unavailable — drop it rather than throw
	}
}

function describe(value) {
	if (value instanceof Error) return `${value.name}: ${value.message}${value.stack ? `\n${value.stack.split("\n").slice(1, 4).join("\n")}` : ""}`;
	if (typeof value === "string") return value;
	try {
		return JSON.stringify(value);
	} catch {
		return String(value);
	}
}

export function logDiagnostic(level, ...parts) {
	const text = parts.map(describe).join(" ").slice(0, MAX_TEXT);
	const list = read();
	list.push({ at: new Date().toISOString(), level, text, route: globalThis.location?.hash ?? "" });
	write(list);
}

export function listDiagnostics() {
	return read().reverse();
}

export function clearDiagnostics() {
	write([]);
}

// Plain text for "Copy": newest first, with the app version.
export function diagnosticsText(version = "") {
	const lines = listDiagnostics().map((e) => `[${e.at}] ${e.level.toUpperCase()} ${e.route}\n${e.text}`);
	return `MediaTracker ${version}\n${navigator.userAgent}\n\n${lines.join("\n\n") || "(no entries)"}`;
}

let installed = false;

// Capture uncaught errors, unhandled rejections, and console.warn / error (the
// app reports sync and refresh trouble through console.warn).
export function installDiagnostics() {
	if (installed || typeof window === "undefined") return;
	installed = true;
	window.addEventListener("error", (e) => logDiagnostic("error", e.error ?? e.message));
	window.addEventListener("unhandledrejection", (e) => logDiagnostic("error", "Unhandled rejection:", e.reason));
	for (const level of ["warn", "error"]) {
		const original = console[level].bind(console);
		console[level] = (...args) => {
			try {
				logDiagnostic(level, ...args);
			} catch {
				// never let logging break logging
			}
			original(...args);
		};
	}
}
